// Kept in sync with @chessla/shared's server-side estimator. This local copy
// avoids CommonJS named-export interop in Vite's browser bundle.
const CPL_TO_RATING: ReadonlyArray<readonly [number, number]> = [
  [10, 2600],
  [25, 2200],
  [40, 1800],
  [60, 1500],
  [80, 1300],
  [100, 1100],
  [130, 900],
  [170, 750],
  [220, 600],
  [300, 450],
  [400, 350],
  [500, 250],
];

export function estimateRatingFromCpl(cpl: number): number {
  if (cpl <= CPL_TO_RATING[0][0]) return CPL_TO_RATING[0][1];
  const last = CPL_TO_RATING.at(-1)!;
  if (cpl >= last[0]) return last[1];
  for (let index = 1; index < CPL_TO_RATING.length; index += 1) {
    const [upperCpl, upperRating] = CPL_TO_RATING[index];
    const [lowerCpl, lowerRating] = CPL_TO_RATING[index - 1];
    if (cpl <= upperCpl) {
      const progress = (cpl - lowerCpl) / (upperCpl - lowerCpl);
      return Math.round(lowerRating + progress * (upperRating - lowerRating));
    }
  }
  return last[1];
}
